import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';

const MerchantCollectionsAddForm = () => {
  const [merchantId, setMerchantId] = useState(null);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [productName, setProductName] = useState('');
  const [brand, setBrand] = useState('');
  const [price, setPrice] = useState('');
  const [description, setDescription] = useState('');

  const [smallImage, setSmallImage] = useState(null);
  const [mediumImage, setMediumImage] = useState(null);
  const [largeImage, setLargeImage] = useState(null);

  // Separate refs for file inputs
  const smallFileRef = useRef(null);
  const mediumFileRef = useRef(null);
  const largeFileRef = useRef(null);

  // Load merchantId from localStorage
  useEffect(() => {
    const googleLogin = localStorage.getItem('googleLogin');
    if (googleLogin == "false") {
      const merchantData = localStorage.getItem('merchantLogin');
      if (merchantData) {
        const parsedData = JSON.parse(merchantData);
        const id = parsedData.merchantId || parsedData.id;
        if (id) setMerchantId(id);
      }
    }else{
      const merchantData = localStorage.getItem('merchantDashboardLogin');
      if (merchantData) {
        const parsedData = JSON.parse(merchantData);
        const id = parsedData.merchantId || parsedData.id;
        if (id) setMerchantId(id);
      }
    }
  }, []);

  // Load categories
  useEffect(() => {
    if (!merchantId) return;
    axios
      .get(
        `https://api.bakpoket.com/api/MerchantCategories?merchantId=${merchantId}&onlyActive=true`
      )
      .then((res) => {
        setCategoryData(res.data);
      })
      .catch((err) => console.log('Category API error:', err));
  }, [merchantId]);

  // File change handlers (send as File, not base64)
  const handleSmallFileChange = (e) => {
    setSmallImage(e.target.files[0]);
  };

  const handleMediumFileChange = (e) => {
    setMediumImage(e.target.files[0]);
  };

  const handleLargeFileChange = (e) => {
    setLargeImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!merchantId) {
      alert('Merchant ID not found.');
      return;
    }

    const formData = new FormData();
    formData.append('MerchantId', merchantId);
    formData.append('Brand', brand);
    formData.append('Price', price);
    formData.append('CategoryId', selectedCategory);
    formData.append('ProductName', productName);
    formData.append('Description', description);

    if (smallImage) formData.append('ImageSmall', smallImage);
    if (mediumImage) formData.append('ImageMedium', mediumImage);
    if (largeImage) formData.append('ImageLarge', largeImage);

    // Debug: log all FormData entries
    // for (let pair of formData.entries()) {
    //   console.log(pair[0], pair[1]);
    // }

    try {
      const res = await axios.post(
        'https://api.bakpoket.com/api/merchantpage/products/UploadFile',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );

      alert('Collection uploaded successfully!');
      // console.log(res.data);

      // Reset form fields
      setProductName('');
      setBrand('');
      setPrice('');
      setDescription('');
      setSelectedCategory('');
      setSmallImage(null);
      setMediumImage(null);
      setLargeImage(null);

      if (smallFileRef.current) smallFileRef.current.value = null;
      if (mediumFileRef.current) mediumFileRef.current.value = null;
      if (largeFileRef.current) largeFileRef.current.value = null;
    } catch (err) {
      console.error('Upload error:', err);
      if (err.response) {
        console.error('Server response:', err.response.data);
      }
      alert('Upload failed. Check console for details.');
    }
  };

  return (
    <Wrapper>
      <Card>
        <h2>Add New Products</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Product Name"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Brand"
            value={brand}
            onChange={(e) => setBrand(e.target.value)}
            required
          />
          <input
            type="number"
            placeholder="Price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            required
          />
          <textarea
            placeholder="Collection Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
            className="mb-2"
          />
          <label className="pb-1 text-start" htmlFor="Category">
            Select Category
          </label>
          <select
            id="Category"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            required
          >
            <option value="">Select Category</option>
            {categoryData.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.categoryName}
              </option>
            ))}
          </select>

          <label className="pb-1 text-start" htmlFor="ImageSmall">
            Small Image
          </label>
          <input
            id="ImageSmall"
            type="file"
            accept="image/*"
            onChange={handleSmallFileChange}
            ref={smallFileRef}
            required
          />

          <label className="pb-1 text-start" htmlFor="ImageMedium">
            Medium Image
          </label>
          <input
            id="ImageMedium"
            type="file"
            accept="image/*"
            onChange={handleMediumFileChange}
            ref={mediumFileRef}
            required
          />

          <label className="pb-1 text-start" htmlFor="ImageLarge">
            Large Image
          </label>
          <input
            id="ImageLarge"
            type="file"
            accept="image/*"
            onChange={handleLargeFileChange}
            ref={largeFileRef}
            required
          />

          <button type="submit">Submit</button>
        </form>
      </Card>
    </Wrapper>
  );
};

export default MerchantCollectionsAddForm;

// ✅ Wrapper to center the Card
const Wrapper = styled.section`
  width: 100%;
  max-width: 1280px;
  margin: 2% auto;
  padding: 15px;
  border-radius: 15px;

  @media (max-width: 768px) {
    padding: 0px;
  }
`;

const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  margin: auto;
  text-align: center;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input[type='file'],
    input[type='text'],
    input[type='number'],
    select,
    textarea {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.3s;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }

  @media (max-width: 768px) {
    max-width: 220px;
    width: 100%;
    padding: 15px;

    h2 {
      font-size: 16px;
    }

    button {
      font-size: 12px;
      padding: 8px 12px;
    }

    input[type='file'],
    input[type='text'],
    input[type='number'],
    select,
    textarea {
      padding: 6px;
      font-size: 11px;
    }
  }
`;
